import React, { FC } from "react";
import { ItemDisplay } from "@narvar/nth-hook-loma";
import {
  ExtendedOrderItem,
  ExtendedReturnItemInput,
  Maybe,
  useLanguage,
} from "@narvar/nth-kit-returns-headless";
import { ItemCard } from "./components";
import { getItemAttrs, getItemProps } from "./utils/itemSelectorHelper";

interface Props {
  orderItems: ExtendedOrderItem[];
  selectedItems?: ExtendedReturnItemInput[];
  itemDisplay?: Maybe<ItemDisplay>;
  locale?: string;
  includeCurrency?: boolean;
}

export const Items: FC<Props> = ({
  itemDisplay,
  orderItems,
  selectedItems,
  locale,
  includeCurrency,
}) => {
  const { rawValue: skuLabel } = useLanguage({
    langKey: "returnsItemListItemInfoskuLabel",
  });
  const { rawValue: qtyLabel } = useLanguage({
    langKey: "returnsItemListItemInfoqtyLabel",
  });
  const { rawValue: colorLabel } = useLanguage({
    langKey: "returnsItemListItemInfocolorLabel",
  });
  const { rawValue: sizeLabel } = useLanguage({
    langKey: "returnsItemListItemInfosizeLabel",
  });
  const { rawValue: reasonLabel } = useLanguage({
    langKey: "returnsItemListItemInforeasonLabel",
  });

  return (
    <>
      {selectedItems?.map((item) => {
        const orderItem = orderItems.find(
          (orderItem) =>
            orderItem.sku === item.sku && orderItem.itemId === item.itemId,
        ) as ExtendedOrderItem;
        const selectedReason = orderItem?.availableReasons?.find(
          //eslint-disable-next-line @typescript-eslint/no-explicit-any
          (reason: any) => reason.id === item.reason.id,
        );
        return (
          <ItemCard
            key={`${item.sku ?? ""}${item.itemId ?? ""}`}
            {...getItemProps({ item: orderItem, exchangeTo: item.exchangeTo })}
            attributes={getItemAttrs({
              locale,
              includeCurrency,
              item: { ...orderItem, quantity: orderItem.remainingQuantity },
              itemDisplay,
              selectedQuantity: item?.quantity,
              labels: {
                skuLabel,
                qtyLabel,
                colorLabel,
                sizeLabel,
              },
              exchangeTo: item.exchangeTo,
            })}
            additionalInfo={`${reasonLabel ?? ""}${selectedReason?.name ?? ""}`}
            hasShippingProtection={orderItem.hasShippingProtection}
          />
        );
      })}
    </>
  );
};
